module.exports = __webpack_public_path__ + "static/media/alert_1.7c891027.svg";